import React, {useEffect, useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import VS from "constants/ValidationShema";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import RegisterEnvelopeForm from "./RegisterEnvelopeForm";
import isResponseValid from "libs/isResponseValid";
import RfxOfferService from "services/RfxOfferService";
import Loading from "components/Loading";
import PropTypes from 'prop-types';
import moment from "libs/moment";

function RegisterEnvelopePopup(
    {
        demandId,
        rfxRoundId,
        onClose,
        envelopeId,
        formSubmit,
    }) {

    const newEnvelope = envelopeId === -1;
    const [error, setError] = useState('');
    const [working, setWorking] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadedEnvelope, setLoadedEnvelope] = useState({});
    const formId = useId();

    useEffect(() => {
        if (newEnvelope) {
            setLoading(false);
        } else {
            RfxOfferService.getEnvelope(rfxRoundId, envelopeId).then((resp) => {
                setLoadedEnvelope(resp);
            }).finally(() => setLoading(false))
        }
    }, [envelopeId, newEnvelope, rfxRoundId])
    const handleSubmit = () => {
        setError('');
        formSubmit[formId]();
    }

    const handleSaveResponse = (response) => {
        if (isResponseValid(response, setError)) {
            onClose();
        }
    }

    const onSubmit = (envelope) => {
        setWorking(true);

        const req = {
            identity: envelopeId,
            dateOfReceipt: envelope.offerDate.format(),
            roundId: rfxRoundId
        }
        if (envelope.suggestContractor) {
            req.invitation = {
                name: envelope.name,
                address: envelope.address,
                postCode: envelope.postCode,
                city: envelope.city,
                vatin: {...envelope.vatin},
                email: envelope.email
            }
        } else {
            req.contractor = {
                identity: envelope.contractorDepartmentId
            }
        }
        RfxOfferService.saveEnvelope(rfxRoundId, req).then((resp) => handleSaveResponse(resp)).finally(() => setWorking(false));
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), () => onClose(true), 'outlined', working));
        buttons.push(createButton(Tr('save'), handleSubmit, undefined, working || loading));
        return buttons;
    }


    return (
        <Dialog
            title={Tr("register_envelope")}
            open={true}
            maxWidth='md'
            dialogActions={<MultiButton buttons={getButtons()}/>}
        >
            {loading ? <Loading/> :
                <Form
                    initialValues={{
                        suggestContractor: false,
                        contractorName: loadedEnvelope.contractor?.name || '',
                        contractorDepartmentId: 0,
                        name: '',
                        email: '',
                        vatin: {
                            number: "",
                            prefix: "PL",
                        },
                        offerDate: loadedEnvelope?.dateOfReceipt ? moment(loadedEnvelope.dateOfReceipt) : null
                    }}
                    validationSchema={Yup.object().shape({
                        contractorName: VS.string(),
                        offerDate: VS.dateMax()
                    })}
                    onSubmit={onSubmit}
                    id={formId}
                >
                    {(formikProps) => (
                        <RegisterEnvelopeForm
                            demandId={demandId}
                            formikProps={formikProps}
                            error={error}
                            newEnvelope={newEnvelope}
                            working={working}
                        />
                    )}
                </Form>
            }
        </Dialog>
    )
}


RegisterEnvelopePopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    rfxRoundId: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    envelopeId: PropTypes.number.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(RegisterEnvelopePopup);